import React from "react";
import ClientProfileSearchModule from "./clientProfileSearchModule";
import ClientProfileSearchSagas from "./redux/clientProfileSearchSagas";
import ClientProfileSearchReducer from "./redux/clientProfileSearchReducer";
import PageWithConfigurator from "../../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Client Profiles Search",
  moduleList: [
    {
      Component: ClientProfileSearchModule,
      moduleName: "clientProfilesSearch",
      saga: ClientProfileSearchSagas(),
      reducer: ClientProfileSearchReducer
    }
  ],
  hideConfigurator: true
};

const ClientProfileSearchPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default ClientProfileSearchPage;
